(() => {
  "use strict";

  const drawer = document.querySelector("[data-cart-drawer]");
  const itemsList = document.querySelector("[data-cart-drawer-items]");
  const emptyState = document.querySelector("[data-cart-drawer-empty]");
  const footer = document.querySelector("[data-cart-drawer-footer]");
  const subtotalEl = document.querySelector("[data-cart-drawer-subtotal]");
  const itemTemplate = document.getElementById("CartDrawerItemTemplate");
  let lastFocusedEl = null;

  // ---------- Cart count (header bag icon) ----------
  function updateCartCount(cart) {
    document.querySelectorAll("[data-cart-count]").forEach((el) => {
      el.textContent = cart.item_count;
    });
  }

  // ---------- Drawer open/close ----------
  function openDrawer() {
    if (!drawer) return;
    lastFocusedEl = document.activeElement;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("cart-drawer-open");
    const closeBtn = drawer.querySelector(".cart-drawer-close");
    if (closeBtn) closeBtn.focus();
    document.addEventListener("keydown", onKeydown);
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("cart-drawer-open");
    document.removeEventListener("keydown", onKeydown);
    if (lastFocusedEl) lastFocusedEl.focus();
  }

  function onKeydown(event) {
    if (event.key === "Escape") closeDrawer();
  }

  document.addEventListener("click", (event) => {
    if (event.target.closest("[data-cart-drawer-toggle]")) {
      event.preventDefault();
      openDrawer();
      renderDrawer();
    }
    if (event.target.closest("[data-cart-drawer-close]")) {
      event.preventDefault();
      closeDrawer();
    }
  });

  // ---------- Rendering the drawer from live cart data ----------
  function moneyFormat(cents) {
    // Uses the shop's active currency formatting already present on the page via Shopify's money filter
    // for the initial render; for client-side updates we fall back to a simple decimal display.
    return (cents / 100).toLocaleString(undefined, { style: "currency", currency: window.Shopify && Shopify.currency ? Shopify.currency.active : "GBP" });
  }

  function buildItemRow(item) {
    if (!itemTemplate) return null;
    const node = itemTemplate.content.cloneNode(true);
    const li = node.querySelector(".cart-drawer-item");
    li.dataset.lineKey = item.key;

    const imageLink = node.querySelector(".cart-drawer-item-image");
    const img = imageLink.querySelector("img");
    imageLink.href = item.url;
    if (item.image) {
      img.src = item.image.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, "_240x240$1$2");
      img.alt = item.title;
    }

    const titleLink = node.querySelector(".cart-drawer-item-title");
    titleLink.href = item.url;
    titleLink.textContent = item.product_title || item.title;

    const variantEl = node.querySelector(".cart-drawer-item-variant");
    if (item.variant_title) {
      variantEl.textContent = item.variant_title;
    } else {
      variantEl.remove();
    }

    const planEl = node.querySelector(".cart-drawer-item-plan");
    // Subscriptions are not currently offered — this only shows if a legacy
    // cart line somehow still carries a selling plan.
    if (item.selling_plan_allocation) {
      planEl.textContent = item.selling_plan_allocation.selling_plan.name;
    } else {
      planEl.remove();
    }

    node.querySelector("[data-qty-value]").textContent = item.quantity;
    node.querySelector(".cart-drawer-item-price").textContent = moneyFormat(item.final_line_price);

    return li;
  }

  function renderDrawer() {
    if (!itemsList) return;
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        updateCartCount(cart);
        itemsList.innerHTML = "";

        if (cart.item_count === 0) {
          if (emptyState) emptyState.hidden = false;
          if (footer) footer.hidden = true;
          return;
        }

        if (emptyState) emptyState.hidden = true;
        if (footer) footer.hidden = false;
        if (subtotalEl) subtotalEl.textContent = moneyFormat(cart.total_price);

        cart.items.forEach((item) => {
          const row = buildItemRow(item);
          if (row) itemsList.appendChild(row);
        });
      })
      .catch(() => {});
  }

  // ---------- Quantity / remove controls inside the drawer ----------
  function changeLineQuantity(lineKey, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: lineKey, quantity }),
    })
      .then((res) => res.json())
      .then(() => renderDrawer())
      .catch(() => {});
  }

  document.addEventListener("click", (event) => {
    const row = event.target.closest(".cart-drawer-item");
    if (!row) return;
    const lineKey = row.dataset.lineKey;
    const currentQty = parseInt(row.querySelector("[data-qty-value]").textContent, 10) || 1;

    if (event.target.closest("[data-qty-increase]")) {
      changeLineQuantity(lineKey, currentQty + 1);
    } else if (event.target.closest("[data-qty-decrease]")) {
      changeLineQuantity(lineKey, Math.max(0, currentQty - 1));
    } else if (event.target.closest("[data-item-remove]")) {
      changeLineQuantity(lineKey, 0);
    }
  });

  // ---------- Add-to-cart: opens the drawer instead of redirecting ----------
  // No subscription/selling-plan handling — plain variant add-to-cart only.
  document.addEventListener("submit", (event) => {
    const form = event.target.closest("form[data-product-form], form[data-landing-form]");
    if (!form) return;

    event.preventDefault();

    const submitBtn = form.querySelector("[data-add-to-cart], [data-landing-button]");
    const errorEl = form.querySelector("[data-form-error]");
    const formData = new FormData(form);

    if (submitBtn) {
      submitBtn.setAttribute("aria-busy", "true");
      submitBtn.disabled = true;
    }
    if (errorEl) errorEl.hidden = true;

    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      headers: { Accept: "application/json" },
    })
      .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        if (!ok) throw new Error(data.description || "Could not add to cart");
        document.dispatchEvent(new CustomEvent("cart:item-added", { detail: data }));
        openDrawer();
        renderDrawer();
      })
      .catch((err) => {
        if (errorEl) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
        } else {
          window.location.href = "/cart";
        }
      })
      .finally(() => {
        if (submitBtn) {
          submitBtn.removeAttribute("aria-busy");
          submitBtn.disabled = false;
        }
      });
  });

  // ---------- Full cart page: update by line key (AJAX, no page reload) ----------
  function refreshCartSection() {
    const sectionId = "main-cart";
    return fetch(`${window.location.pathname}?sections=${sectionId}`)
      .then((res) => res.json())
      .then((data) => {
        const html = data[sectionId];
        const parser = new DOMParser();
        const newDoc = parser.parseFromString(html, "text/html");
        const newContent = newDoc.getElementById("main-cart");
        const oldContent = document.getElementById("main-cart");
        if (newContent && oldContent) {
          oldContent.replaceWith(newContent);
        }
      });
  }

  function updateCartLine(lineKey, quantity) {
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: { [lineKey]: quantity } }),
    })
      .then((res) => res.json())
      .then((cart) => {
        updateCartCount(cart);
        return refreshCartSection();
      });
  }

  document.addEventListener("click", (event) => {
    const removeBtn = event.target.closest("[data-cart-page-remove]");
    if (!removeBtn) return;
    const lineKey = removeBtn.dataset.lineKey;
    if (!lineKey) return;
    updateCartLine(lineKey, 0);
  });

  document.addEventListener("change", (event) => {
    const qtyInput = event.target.closest("[data-cart-page-qty]");
    if (!qtyInput) return;
    const lineKey = qtyInput.dataset.lineKey;
    if (!lineKey) return;
    const quantity = Math.max(0, parseInt(qtyInput.value, 10) || 0);
    updateCartLine(lineKey, quantity);
  });

  // Keep the header count correct even on plain page loads (e.g. after a full /cart page update).
  fetch("/cart.js")
    .then((res) => res.json())
    .then(updateCartCount)
    .catch(() => {});
})();
